module.exports = __webpack_public_path__ + "static/media/02.4eaec521.jpg";